import BannerCallImg from "assets/banner/banner_call.png";
import { ilshinGroupPhone } from "hooks/utils/util";

const BannerCall = ({ type }: { type: string }) => {
    return (
        <div
            className={`relative h-[262px] w-[282px] border rounded-[20px] text-white pt-[32px] px-[38px] ${type === "air" ? "bg-air" : type === "morning" ? "bg-morning" : type === "quick" ? "bg-quick" : "bg-express"}`}
        >
            <p className="text-[22px] font-bold pb-[5px]">고객센터</p>
            <p className="text-[30px] pt-10 pb-[10px] font-semibold">{ilshinGroupPhone(type)}</p>
            <p className="text-sm">
                평일 : 09:00~18:00 <br /> 토요일 : 09:00~12:00
            </p>
            <img className="absolute top-10 right-7" src={BannerCallImg} alt="bannerCall" />
        </div>
    );
};

export default BannerCall;
